import { render, staticRenderFns } from "./paymentCallback.vue?vue&type=template&id=65632d53&scoped=true&"
import script from "./paymentCallback.vue?vue&type=script&lang=js&"
export * from "./paymentCallback.vue?vue&type=script&lang=js&"
import style0 from "./paymentCallback.vue?vue&type=style&index=0&id=65632d53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65632d53",
  null
  
)

export default component.exports